import Vue from 'vue';
import cookies from 'js-cookie';
import Element from 'element-ui';
import VueI18n from 'vue-i18n';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import zhTwLocale from 'element-ui/lib/locale/lang/zh-TW';

Vue.use(VueI18n);
/* 根据浏览器语言环境切换语言文件 */
/*var language = navigator.language || navigator.userLanguage; //常规浏览器语言和IE浏览器
language = language.substr(0, 2); //截取lang前2位字符
if (window.messages[language] !== undefined && window.messages[language] !== null && cookies.get('tiandy_jp_language') === undefined) {
    cookies.set('tiandy_jp_language', language, { expires: 365 });
}*/
const messages = window.messages;
if (messages.zh) {
    messages.zh = Object.assign(messages.zh, zhLocale);
}
if (messages.en) {
    messages.en = Object.assign(messages.en, enLocale);
}
if (messages.cf) {
    messages.cf = Object.assign(messages.cf, zhTwLocale);
}

const i18n = new VueI18n({
    // set locale
    locale: cookies.get('tiandy_jp_language') || window.app.defaultLanguage,
    // set locale messages
    messages
});
Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value)
});
export default i18n;
